import { AFDataObject, AFMessageType } from ".";

export enum TokenCategory {
  NONE = 'None',
  RANDOM = 'Random',
  PROJECT = 'Project',
  NEWS = 'News',
  TIKTOK = 'Tiktok',
}

export const TOKEN_CATEGORY_LABELS = {
  [TokenCategory.NONE]: '',
  [TokenCategory.RANDOM]: 'Random',
  [TokenCategory.PROJECT]: 'Project',
  [TokenCategory.NEWS]: 'News',
  [TokenCategory.TIKTOK]: 'Tiktok',
} as const;

export enum TokenStatus {
  NONE = 'None',
  FETCHING_DATA = 'Fetching Data',
  REVIEWING = 'Reviewing',
  READY_FOR_IC = 'Ready for IC',
  BUY = 'Buy',
  NOT_BUY = 'Not Buy',
  HOLD = 'Hold',
  LATER = 'Later',
  SOLD = 'Sold',
  FETCHING_FAILED = 'Fetching Failed',
}

export const TOKEN_STATUS_LABELS = {
  [TokenStatus.NONE]: '',
  [TokenStatus.FETCHING_DATA]: 'Fetching',
  [TokenStatus.REVIEWING]: 'Review',
  [TokenStatus.READY_FOR_IC]: 'IC Ready',
  [TokenStatus.BUY]: 'Buy',
  [TokenStatus.NOT_BUY]: 'Not Buy',
  [TokenStatus.HOLD]: 'Hold',
  [TokenStatus.LATER]: 'Later',
  [TokenStatus.SOLD]: 'Sold',
  [TokenStatus.FETCHING_FAILED]: 'Failed',
} as const;

export interface FeTokenStateRawData {
  tokenAddress: string;
  isArchived: boolean;
  archivedAt?: string | Date;
  category: TokenCategory;
  memo?: string;
  status?: TokenStatus;
  contentsExists?: boolean;
  totalScore?: number;
}

export interface FeTokenStateStateData extends FeTokenStateRawData {
  lastUpdated: Date;
}

export class FeTokenState implements AFDataObject<FeTokenStateRawData, FeTokenStateStateData> {
  public tokenAddress: string;
  public isArchived: boolean;
  public archivedAt?: Date;
  public category: TokenCategory;
  public memo?: string;
  public status: TokenStatus;
  public contentsExists: boolean;
  public totalScore: number;
  public lastUpdated: Date;

  constructor(data: FeTokenStateRawData | null, lastUpdated?: Date) {
    // 기본값 설정
    this.tokenAddress = data?.tokenAddress || '';
    this.isArchived = data?.isArchived || false;
    this.archivedAt = data?.archivedAt 
      ? (typeof data.archivedAt === 'string' ? new Date(data.archivedAt) : data.archivedAt)
      : undefined;
    this.category = data?.category || TokenCategory.NONE;
    this.memo = data?.memo || undefined;
    this.status = data?.status || TokenStatus.NONE;
    this.contentsExists = data?.contentsExists || false;
    this.totalScore = data?.totalScore || 0;
    this.lastUpdated = new Date(lastUpdated || 0);
  }

  static create(data: FeTokenStateRawData | null, lastUpdated?: Date): FeTokenState {
    return new FeTokenState(data, lastUpdated);
  }

  getMessageType(): AFMessageType {
    return AFMessageType.FE_TOKEN_STATE;
  }

  toRawData(): FeTokenStateRawData {
    return {
      tokenAddress: this.tokenAddress,
      isArchived: this.isArchived,
      archivedAt: this.archivedAt,
      category: this.category,
      memo: this.memo,
      status: this.status,
      contentsExists: this.contentsExists,
      totalScore: this.totalScore,
    };
  }

  toStateData(): FeTokenStateStateData {
    return {
      ...this.toRawData(),
      lastUpdated: this.lastUpdated
    };
  }

  filter(existingData: FeTokenStateStateData): boolean {
    return Number(this.lastUpdated) > Number(existingData.lastUpdated);
  }
}
